export enum Environment {
  nonprod = "nonprod",
  prod = "prod",
  local = "local",
  none = "none"
}
